<template>
  <div class="container">
    <vue-element-loading :active="isActive" spinner="spinner" color="#FF6700" background-color="rgba(0, 0, 0, .2)"/>
    <!-- 填写保修单 -->
   <div class="box">
    <div class="newconsult-info">
      <div class="newconsult-info-row-1" @click="handleGoChooseBar">
        <span>网吧</span>
        <input v-reset-page  type="text" :value="siteName" disabled />
      </div>
      <div class="newconsult-info-row-2">
        <span>网吧地址</span>
        <input v-reset-page  type="text" placeholder="请输入" v-model="siteAddress" />
      </div>
    </div>
    <!-- 联系人信息 -->
    <div class="newconsult-info2">
      <div class="newconsult-info-row-1">
        <span>联系人</span>
        <input v-reset-page  type="text" placeholder="请输入" v-model="contact" />
      </div>
      <div class="newconsult-info-row-2">
        <span>联系电话</span>
        <input v-reset-page 
          type="number"
          placeholder="请输入"
          v-model="phone"
          oninput="if(value.length>11)value=value.slice(0,11)"
          pattern="[0-9]*"
        />
      </div>
      <div class="newconsult-info-row-3" @click="handleSelectTypeShow">
        <span>咨询类型</span>
        <span class="selectType">{{consultTypeName}}</span>
      </div>
    </div>
    <!-- 保修描述 -->
    <div class="newconsult-info3">
      <div class="title">咨询描述</div>
      <div class="textarea">
        <textarea v-reset-page  name id cols="30" rows="10" placeholder="您可以在此描述需要咨询的内容" v-model="description"></textarea>
      </div>
      <div class="title">
        上传图片
        <span class="prompt">（最多9张）</span>
      </div>
      <div class="uploader-image">
        <van-uploader
          :after-read="afterRead"
          :before-delete="beforeDelete"
          v-model="fileList"
          multiple
          :max-count="9"
          :preview-size="60"
          @click-preview="clickPreview"
          @close-preview="closePreview"
        />
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="plbm-btn" @click="isLoadingClick && handleSubmitClick()">提交</div>
    </div>
    <!-- 保修类型选择 -->
    <van-popup v-model="statusShow" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        :columns="columns"
        confirm-button-text="完成"
        value-key="name"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
      <van-loading color="#008cff" v-show="isLoadingShow"/>
  </div>
</template>

<script>
import { Uploader } from "vant";
import { Popup } from "vant";
import { Picker } from "vant";
import { Toast, Dialog,Loading } from "vant";
import {
  ConsultaionSave,
  ConsultaionType,
  ConsultaionInfo
} from "@/api/consultation";
import { UploadFile } from "@/api/public";
import axios from "axios";
import Exif from "exif-js";
import VueElementLoading from 'vue-element-loading';
export default {
  components: {
    vanUploader: Uploader,
    vanPicker: Picker,
    vanPopup: Popup,
    VueElementLoading,
    vanLoading:Loading
  },
  data() {
    return {
      uploadImagePathList: [],
      columns: [],
      fileList: [],
      columns: [],
      statusShow: false,
      siteName: "",
      siteAddress: "",
      consultTypeId: "",
      consultTypeName: "请输入",
      contact: "",
      phone: "",
      description: "",
      arr: "",
      internetBarId: "",
      updataSiteAddress: "",
      isActive:false,
      isLoadingShow:false,
      isLoadingClick:true
    };
  },
  mounted() {
    // let internet_bar_id = sessionStorage.getItem('internetBarId')
    let internet_bar_id =  this.$cookies.get('internetBarId')
    this.internetBarId = internet_bar_id;
    this.requestConsultaionType();
    this.requestConsultaionInfo();
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.closePreview, false); //false阻止默认事件
    }
  },
  destroyed(){
     window.removeEventListener('popstate', this.closePreview, false);//false阻止默认事件
   },
  methods: {
   clickPreview() {
        history.pushState(null, null, document.URL);
    },
    closePreview() {
        console.log('关闭了')
    },
    afterRead(file) {
      console.log("length = " + file.length);
      console.log("fileList" + file);
      console.log("店家");
      let fileArray = [];
      if (file.length > 1) {
        fileArray = file;
      } else {
        fileArray.push(file);
      }

      let that = this;
      that.isActive = true;
      fileArray.forEach(imageFile => {
        console.log("店家:" + imageFile);
        let formData = new window.FormData();
        this.$utils.compress(imageFile.file, 0.5, function(err, data) {
          if (err) {
            console.log(err);
            return;
          }
          formData.append("file", data);
          let config = {
            headers: { "Content-Type": "multipart/form-data" }
          };
          // HTUploadFile({formData}).then(res =>{
          //     console.log(res)
          // });
          // 添加请求头
          // let baseUrl = this.$utils.getBaseUrl();
          axios
            .post(
              "https://kf.qingruilin.com.cn/netbar/api/common/v1/pic_upload",
              formData,
              config
            )
            .then(response => {
              let res = response.data;
              console.log(res.data);
              if (res.code == 200) {
                console.log("地址:" + res.data.relativePicPath);
                //  that.arr += res.data.relativePicPath + ','
                that.uploadImagePathList.push(res.data.relativePicPath);
                that.isActive = false;
              }
            });
        });
      });
    },
    beforeDelete(index) {
      this.uploadImagePathList.splice(index, 1);
      return true;
    },
    //  保修类型的chaage事件
    onConfirm(value, index) {
      this.statusShow = false;
      console.log(value);
      this.consultTypeId = value.dataId;
      this.consultTypeName = value.name;
    },

    // 点击取消的时候隐藏
    onCancel() {
      this.statusShow = false;
    },
    // 类型选择
    requestConsultaionType() {
      ConsultaionType().then(res => {
        console.log(res);
        let columnsArr = res.data;
        let newcolumnsArr = [];
        columnsArr.forEach((item, index) => {
          newcolumnsArr.push(item);
        });
        console.log(newcolumnsArr);
        this.columns = newcolumnsArr;
      });
    },
        // 跳转选择网吧
    handleGoChooseBar() {
      console.log('11')
        this.$router.push({
           path:'/choosebar',
           query:{
              url:'/consultnew'
           }
        })
    },
    //获取网吧的信息
    requestConsultaionInfo() {
      ConsultaionInfo({internetBarId:this.internetBarId}).then(res => {
        console.log(res);
        this.siteName = res.data.siteName;
        this.siteAddress = res.data.siteAddress;
        this.updataSiteAddress = this.siteAddress;
      });
    },
    requestConsultaionSave() {
      let contact = this.contact;
      let phone = this.phone;
      let consultTypeId = this.consultTypeId;
      let description = this.description;
      let internetBarId = this.internetBarId;
      let siteAddress = this.siteAddress;
       let arr = this.uploadImagePathList.join(",");
      if (!contact) {
        Toast("联系人不能为空");
        return false;
      }
      if (!phone) {
        Toast("手机号不能为空");
        return false;
      }
      if (!consultTypeId) {
        Toast("类型不能为空");
        return false;
      }
      if (!description) {
        Toast("描述不能为空");
        return false;
      }
      // if (!arr) {
      //   Toast("请上传图片");
      //   return false;
      // }
      this.isLoadingShow = true
      if(this.isLoadingShow) {
          this.isLoadingClick = false
        }else {
          this.isLoadingClick = true 
        }
      ConsultaionSave({
        siteAddress: siteAddress,
        consultName: contact,
        consultPhone: phone,
        consultTypeId: consultTypeId,
        questionDescribe: description,
        internetBarId: internetBarId,
        pictureUrl: arr
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
           this.$router.push({
            path:'/consultrecords'
          });
        }
      });
    },
    async requestUploadFile(base64Img) {
      UploadFile({ base64Img: base64Img }).then(res => {
        console.log(res);
        this.arr += res.data + ",";
      });
    },
    // 是否展示选择保修类型
    handleSelectTypeShow: function() {
      this.statusShow = !this.statusShow;
    },
    // 点击保存
    handleSubmitClick() {
      // 点击判断地址是否一致
      if (this.siteAddress != this.updataSiteAddress) {
        Dialog.confirm({
          title: "提示",
          message: "是否修改网吧基本信息中的地址"
        })
          .then(() => {
            this.requestConsultaionSave();
          })
          .catch(() => {
            this.requestConsultaionInfo();
          });
      } else {
        this.requestConsultaionSave();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  max-height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  position:static;
    .box {
       height:calc(100vh + 1px);
      // 第一个模块
      .newconsult-info {
        width: 375px;
        height: 106px;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        border-bottom: 1px solid #f2f2f2;
        .newconsult-info-row-1 {
          width: 100%;
          height: 50px;
          padding: 18px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            border: none;
            width: 210px;
            margin-left: 60px;
            &:disabled {
              background-color: #ffffff;
            }
          }
        }
        .newconsult-info-row-2 {
          width: 100%;
          height: 50px;
          line-height: 50px;
          box-sizing: border-box;
          input {
            border: none;
            width: 230px;
            margin-left: 30px;
            &:disabled {
              background-color: #ffffff;
            }
          }
        }
      }
      // 第二个模块
      .newconsult-info2 {
        width: 375px;
        height: 158px;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        .newconsult-info-row-1 {
          width: 100%;
          height: 50px;
          padding: 18px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            border: none;
            margin-left: 43px;
          }
        }
        .newconsult-info-row-2 {
          width: 100%;
          height: 50px;
          padding: 18px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            border: none;
            margin-left: 30px;
          }
        }
        .newconsult-info-row-3 {
          width: 100%;
          height: 50px;
          line-height: 50px;
          box-sizing: border-box;
          .selectType {
            border: none;
            margin-left: 30px;
            color: #999999;
          }
        }
      }
      // 第三个模块信息描述
      .newconsult-info3 {
        width: 375px;
        // height: 100%;
        overflow-x: hidden;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        .title {
          text-align: left;
          padding: 18px 0;
          box-sizing: border-box;
          .prompt {
            color: #999999;
            font-size: 13px;
          }
        }
        .textarea {
          width: 100%;
          height: 100%;
          textarea {
            background-color: #eaeaea;
            width: 349px;
            height: 100px;
            border: none;
            border-radius: 8px;
            padding: 15px 10px;
            box-sizing: border-box;
            &::-webkit-input-placeholder {
              color: #999999;
            }
          }
        }
        //上传图片
        .van-uploader {
          margin-bottom: 20px;
        }
      }
      .plbm-btn {
        width: 350px;
        height: 44px;
        background: -webkit-linear-gradient(left, #05aefc, #008cff);
        margin: 0 auto;
        border-radius: 22px;
        font-size: 16px;
        color: $white-color;
        line-height: 44px;
        margin: 37px auto;
      }
      // 选择保修类型
      .select-type {
        width: 100%;
        position: fixed;
        bottom: 0;
      }
  }
}
</style>
<style lang="scss">
.van-uploader__preview {
  margin-left: 6px;
}
.select-type {
  .van-picker__cancel {
    color: #333333;
    font-size: 17px;
  }
  .van-picker__confirm {
    color: #333333;
    font-size: 17px;
  }
}
</style>